import { render, staticRenderFns } from "./heart-minus-icon.vue?vue&type=template&id=33b01a1e&"
import script from "./heart-minus-icon.vue?vue&type=script&lang=js&"
export * from "./heart-minus-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports